const css = `._59pHrG__header{cursor:pointer;width:100%;border-radius:var(--sizing-border-radius-small);outline-offset:3px;outline:3px solid #0000;align-items:center;display:flex}._59pHrG__header:focus-visible{outline:3px solid var(--base-strokes-focus);outline-offset:3px;z-index:1}._59pHrG__iconWrapper{transition:transform .3s}._59pHrG__iconWrapper._59pHrG__expanded{transform:rotate(90deg)}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"header":"_59pHrG__header","iconWrapper":"_59pHrG__iconWrapper","expanded":"_59pHrG__expanded"};
